import env from './config';
import { Auth } from 'aws-amplify';
const {
  REGION: region,
  COGNITO_USER_POOL_ID: userPoolId,
  COGNITO_IDENTITY_POOL_ID: identityPoolId,
  COGNITO_CLIENT_ID: userPoolWebClientId,
  API_VERSION,
  REALM,
  APPSYNC_URL
} = env;

const config = {
  aws_appsync_graphqlEndpoint: APPSYNC_URL,
  aws_appsync_region: 'ap-northeast-1',
  aws_appsync_authenticationType: 'AWS_IAM',

  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId,

    // REQUIRED - Amazon Cognito Region
    region,

    // Amazon Cognito User Pool ID
    userPoolId,
    // Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId,

    mandatorySignIn: true,
  },

  API: {
    endpoints: [
      {
        name: 'getFiles',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-get-user-files/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      },
      {
        name: 'getUploadUrl',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-get-file-upload-url/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      },
      {
        name: 'getDevices',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-get-devices/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      },
      {
        name: 'getRecentMovieList',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-get-movie-list/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      },
      {
        name: 'startDownload',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-start-download/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      },
      {
        name: 'getDownloadStatus',
        endpoint: `https://lambda.ap-northeast-1.amazonaws.com/2015-03-31/functions/api-${REALM}-${API_VERSION}-get-download-status/invocations`,
        service: 'lambda',
        region: 'ap-northeast-1'
      }
    ]
  }
};

export default config;

export const getCredential = async() => {
  const result = await Auth.currentUserCredentials();
  return result;
};
